module.exports = __webpack_public_path__ + "media/icons/refresh-8663a053.svg";